import {
  mdiCogs,
  mdiHomeVariant,
  mdiAccountCheck,
  mdiPhoneMessage,
  mdiOfficeBuilding,
  mdiHome,
  mdiHistory,
  mdiDomain,
  mdiAccountBox,
  mdiChartBar,
  mdiAccount,
  mdiAccountMultipleOutline,
  mdiFileDocumentOutline,
  mdiFileTableBoxMultipleOutline,
  mdiFileChartOutline,
  mdiAccountDetails,
  mdiDatabasePlus,
  mdiAccountKeyOutline
} from "@mdi/js";
const sidebarItems = [
  {
    title: "Overview",
    icon: mdiHome,
    to: { name: "overview" }
  },
  {
    title: "Activity Logs",
    icon: mdiHistory,
    to: { name: "activity-logs" }
  },
  {
    title: "Settings",
    icon: mdiCogs,
    children: [
      {
        title: "Organization Specific",
        icon: mdiHomeVariant,
        to: { name: "settings-organization" }
      },
      
      {
        title: "Client Designation",
        icon: mdiAccountCheck,
        to: { name: "settings-designation" }
      },
      {
        title: "Communication Mediums",
        icon: mdiPhoneMessage,
        to: { name: "settings-communication-mediums" }
      },
      {
        title: "Roles and Permissions",
        icon: mdiAccountKeyOutline,
        to: { name: "settings-roles-and-permissions" }
      },
      {
        title: "Industry",
        icon: mdiOfficeBuilding,
        to: { name: "settings-industry" }
      },
      {
        title: "CRM Users",
        icon: mdiAccount,
        to: { name: "settings-crm-users" }
      },
      {
        title: "Department and Teams",
        icon: mdiAccountMultipleOutline,
        to: { name: "settings-department-and-teams" }
      }
    ]
  },
  {
    title: "Clients",
    icon: mdiDomain,
    children: [
      {
        title: "List",
        icon: mdiDomain,
        to: { name: "clients" }
      },
      {
        title: "Contact Directory",
        icon: mdiAccountBox,
        to: { name: "contact-persons" }
      }
    ]
  },
  {
    title: "Report",
    icon: mdiChartBar,
    children: [
      {
        title: "Client Value",
        icon: mdiAccountDetails,
        to: { name: "report-client-value" }
      },
      {
        title: "Sales Stage",
        icon: mdiFileChartOutline,
        to: { name: "report-sales-stage" }
      },
      {
        title: "Activity Log",
        icon: mdiFileTableBoxMultipleOutline,
        to: { name: "report-activity-log" }
      },
      {
        title: "Industry",
        icon: mdiDomain,
        to: { name: "report-industry" }
      },
    ]
  },
  {
    title: "Client Source",
    icon: mdiDatabasePlus,
    to: { name: "settings-client-source" }
  },
  {
  
    title: "Client Follow Up",
    icon: mdiAccountMultipleOutline,
    to: { name: "report-client-follow-up" }

  },
  {
    title: "Documents",
    icon: mdiFileDocumentOutline,
    to: { name: "settings-documents" }
  },
];

export default sidebarItems;
